import { registerPlugin } from '@capacitor/core'

import type { GrilldPushNotificationsPlugin } from './definitions'

const GrilldPushNotifications = registerPlugin<GrilldPushNotificationsPlugin>('GrilldPushNotifications', {})

export * from './definitions'
export { GrilldPushNotifications }
